module.exports = __webpack_public_path__ + "img/rec-06.8323edef.jpg";